import { erpAxios } from '..';

const editTroskoviDomacinstva = async (data) => {
  const res = await erpAxios.post(`/troskovi-domacinstva/edit`, data);
  return res;
};

export default editTroskoviDomacinstva;
